import * as React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'

import ApiCard from '../ApiCard'
import { Api } from '../../definitions/Api'
import { Fetch, FetchResult } from '../Fetch'


const styles = (theme: any) => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardGrid: {
    padding: `${theme.spacing.unit * 8}px 0`,
  }
})


export interface CardGridProps {
  classes: any
}

export class CardGrid extends React.Component<CardGridProps, any> {


  listCards(apis: Api[]): JSX.Element[] {
    return apis.map((api: Api) =>
      <Grid item key={api.name} sm={3} md={5} lg={3}>
        <ApiCard api={api} />
      </Grid>
    )
  }

  errorComponent(error: Error) {
    console.error(error)
    return <div>Error: could not fetch</div>
  }

  render() {
    const { classes } = this.props;

    return (
      <Fetch resource="Apis">
        {
          ({ error, result, loading }: FetchResult): JSX.Element => {
            if (error) {
              return this.errorComponent(error)
            }
            else if (!loading) {
              return (
                <div className={classNames(classes.layout, classes.cardGrid)}>
                  <Grid container spacing={40}>
                    {this.listCards(result)}
                  </Grid>
                </div>
              )
            }
          }
        }
      </Fetch>
    )
  }
}

export default withStyles(styles)(CardGrid);
